module.exports = __webpack_public_path__ + "media/flame_100.9705aee9.webm";